import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import FormattedMomentDate from './FormattedMomentDate';

loadDOMComponent({
	selector: 'react-formatted-moment-date',
	callback: ({ container, context, props }: any) => {
		const format = container.getAttribute('format');
		const date = container.getAttribute('date');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<FormattedMomentDate date={date} format={format} />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
